export const familieopstellingReviews = [
  {
    id: 'review-romina',
    author: 'Romina',
    rating: 5,
    reviewBody: 'Ik mocht deelnemen aan de opstellingsochtend bij Marthe en heb dit als prettig ervaren. Haar rust, nuchterheid en fijngevoelige afstemming maakte dat de opstelling in vertrouwen kon plaats vinden. Zeker een aanrader om bij Marthe een familie- of organisatieopstelling te volgen. Duiken in de onderstroom voor managers en leidinggevende is ook een mooie aanvulling geweest voor mijn bedrijf (gevolgd door de teammanager) en heeft veel rijke inzichten gegeven.',
    datePublished: '2026-04-07'
  },
  {
    id: 'review-jolanda',
    author: 'Jolanda',
    rating: 5,
    reviewBody: 'Wat een mooie ochtend, Marthe. Nogmaals bedankt voor je fijne en warme begeleiding. Zoveel rust en geduld, met oog voor iedereen. Het was fijn om er te zijn. Bij thuiskomst was ik gevloerd en vervuld tegelijk. Veel herkenning en dingen aangeraakt in mij, en dat als representant. En letterlijk en figuurlijk in beide opstellingen werd er een spiegel voorgehouden. Alles bij elkaar voelt als een voorproefje wanneer ik binnenkort de vraagsteller ben.',
    datePublished: '2026-04-10'
  },
  {
    id: 'review-kenneth',
    author: 'Kenneth Nelson',
    rating: 5,
    reviewBody: 'Het was een hele gezellige - leerzame en inzichtelijke dag met veel leuke en lieve mensen.',
    datePublished: '2025-06-15'
  },
  {
    id: 'review-marendsen',
    author: 'M Arendsen',
    rating: 5,
    reviewBody: 'Het was een bijzondere, liefdevolle en fijne middag. Marthe zet een veilige setting neer en begeleid met hart en ziel. Geeft alle ruimte die nodig is zodat er gezien kan worden, wat gezien "moet" worden.',
    datePublished: '2025-06-13'
  },
  {
    id: 'review-wieke',
    author: 'Wieke',
    rating: 5,
    reviewBody: 'Het was mijn eerste ervaring met een opstellingenavond en ik had het denk ik niet beter kunnen treffen. Ik voelde me zeer welkom en meegenomen in het proces. Overall een heel prettige ervaring in een fijne en veilige omgeving.',
    datePublished: '2025-01-16'
  }
];

